module.exports = __webpack_public_path__ + "static/img/jb_pic3.d54fd4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jb_pic3.jpg
// module id = RGUw
// module chunks = 5